import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { getConfig } from "@jti/fe-common";
import { isInStock } from "../../utils/isInStock";
import { ProductConfigurableBlock } from "./ProductConfigurableBlock";
import "./ProdutConfigurables.scss";
const getOptions = (options, stock) => {
    const config = getConfig();
    if (!stock) {
        return [];
    }
    const { displayOutOfStockVariants } = config;
    return options.filter(({ sku }) => {
        if (!sku || !stock[sku]) {
            return false;
        }
        return displayOutOfStockVariants || isInStock(stock[sku]);
    });
};
export const ProductConfigurables = ({ options, currentId, stockStatusElements }) => {
    if (!options || options?.length === 0) {
        return _jsx(React.Fragment, {});
    }
    return (_jsx("div", { className: "product-configuration-block", children: options.map(({ list, categoryName }) => (_jsx(ProductConfigurableBlock, { label: categoryName, options: getOptions(list, stockStatusElements), stock: stockStatusElements, value: currentId }, categoryName))) }));
};
//# sourceMappingURL=ProductConfigurables.js.map